<template>
    <div class="Sac-Principal">
        <PageTitle icon="fa fa-phone" main="Solicitações"
            sub="Atendimento aos colaboradores" />
        <div class="Sac-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="SAC" active><SacSolicitacao /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import SacSolicitacao from '../sac_solicitacao/SacSolicitacao'
export default {
    name: 'SacPrincipal',    
    components: { PageTitle, SacSolicitacao}
    
}
</script>

<style>

</style>






